export const CAMPAIGN_EVENT_BUS_NAME = 'campaign-events'

export const CURRENT_BUILDER_ITERATION = 1

export const CONDITION_BRANCH_ROOT = 'branches'
export const CONDITION_BRANCH_PREFIX = 'condition_'
export const DEFAULT_CONDITION_BRANCH_ID = `${CONDITION_BRANCH_PREFIX}default`
